"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ed2curve = require("ed2curve");
var sodium = require("libsodium-wrappers-sumo");
var ClassUtil_1 = require("../util/ClassUtil");
var ArrayUtil_1 = require("../util/ArrayUtil");
var InputError_1 = require("../errors/InputError");
var SecretKey = (function () {
    function SecretKey() {
        this.sec_curve = new Uint8Array([]);
        this.sec_edward = new Uint8Array([]);
    }
    SecretKey.new = function (sec_edward, sec_curve) {
        var sk = ClassUtil_1.default.new_instance(SecretKey);
        sk.sec_edward = sec_edward;
        sk.sec_curve = sec_curve;
        return sk;
    };
    SecretKey.prototype.sign = function (message) {
        return sodium.crypto_sign_detached(message, this.sec_edward);
    };
    SecretKey.prototype.shared_secret = function (public_key) {
        var shared_secret = sodium.crypto_scalarmult(this.sec_curve, public_key.pub_curve);
        ArrayUtil_1.default.assert_is_not_zeros(shared_secret);
        return shared_secret;
    };
    SecretKey.prototype.encode = function (encoder) {
        encoder.object(1);
        encoder.u8(0);
        return encoder.bytes(this.sec_edward);
    };
    SecretKey.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(SecretKey);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.sec_edward = new Uint8Array(decoder.bytes());
                    break;
                default:
                    decoder.skip();
            }
        }
        var sec_curve = ed2curve.convertSecretKey(self.sec_edward);
        if (sec_curve) {
            self.sec_curve = sec_curve;
            return self;
        }
        throw new InputError_1.default.ConversionError('Could not convert public key with ed2curve.', 408);
    };
    return SecretKey;
}());
exports.default = SecretKey;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/SecretKey.js
// module id = 39
// module chunks = 0 1